import {
  add,
  addMonths,
  addWeeks,
  endOfMonth,
  format,
  formatISO,
  sub,
  subMonths,
  subWeeks,
} from 'date-fns';
import { useState, forwardRef } from 'react';
import DatePicker from 'react-datepicker';

import { DEFAULT_DATE_FORMATE } from '../../../constents';
import { startOfMonth } from 'date-fns';

export default function PeriodSelection({ selectedPeriod, setPeriodFilter }) {
  const [datePickerIsOpen, setDatePickerIsOpen] = useState(false);

  function openDatePicker() {
    setDatePickerIsOpen(!datePickerIsOpen);
  }

  function handleDateSelect(dateEvent) {
    setDatePickerIsOpen(!datePickerIsOpen);
    setPeriodFilter({
      name: 'day',
      startDate: formatISO(dateEvent),
      endDate: formatISO(dateEvent),
    });
  }

  // eslint-disable-next-line react/display-name
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="example-custom-input" onClick={onClick} ref={ref}>
      {value}
    </div>
  ));

  function nextDate() {
    if (selectedPeriod.name === 'day') {
      const nextDate = add(new Date(selectedPeriod.startDate || Date.now()), {
        days: 1,
      });
      setPeriodFilter({
        name: 'day',
        startDate: formatISO(nextDate),
        endDate: formatISO(nextDate),
      });
    } else if (selectedPeriod.name === 'week') {
      const nextWeekStart = addWeeks(new Date(selectedPeriod.startDate), 1);
      const nextWeekEnd = addWeeks(new Date(selectedPeriod.endDate), 1);
      setPeriodFilter({
        name: 'week',
        startDate: formatISO(nextWeekStart),
        endDate: formatISO(nextWeekEnd),
      });
    } else if (selectedPeriod.name === 'month') {
      const nextMonthStart = startOfMonth(
        addMonths(new Date(selectedPeriod.startDate), 1),
      );
      const nextMonthEnd = endOfMonth(
        addMonths(new Date(selectedPeriod.endDate), 1),
      );

      setPeriodFilter({
        name: 'month',
        startDate: formatISO(nextMonthStart),
        endDate: formatISO(nextMonthEnd),
      });
    }
  }

  function prevDate() {
    if (selectedPeriod.name === 'day') {
      const previousDate = sub(
        new Date(selectedPeriod.startDate || Date.now()),
        { days: 1 },
      );
      setPeriodFilter({
        name: 'day',
        startDate: formatISO(previousDate),
        endDate: formatISO(previousDate),
      });
    } else if (selectedPeriod.name === 'week') {
      const previousWeekStart = subWeeks(new Date(selectedPeriod.startDate), 1);
      const previousWeekEnd = subWeeks(new Date(selectedPeriod.endDate), 1);

      setPeriodFilter({
        name: 'week',
        startDate: formatISO(previousWeekStart),
        endDate: formatISO(previousWeekEnd),
      });
    } else if (selectedPeriod.name === 'month') {
      const previousMonthStart = startOfMonth(
        subMonths(new Date(selectedPeriod.startDate), 1),
      );

      const previousMonthEnd = endOfMonth(
        subMonths(new Date(selectedPeriod.endDate), 1),
      );
      setPeriodFilter({
        name: 'month',
        startDate: formatISO(previousMonthStart),
        endDate: formatISO(previousMonthEnd),
      });
    }
  }

  return (
    <div className="appt-d-display-val">
      <span className="clear-right10" onClick={prevDate}>
        &#9664;
      </span>
      <span className="appt-d">
        {(selectedPeriod.name === 'day' && (
          <DatePicker
            selected={new Date(selectedPeriod.startDate)}
            onChange={handleDateSelect}
            onClickOutside={openDatePicker}
            open={datePickerIsOpen}
            onSelect={handleDateSelect}
            customInput={<ExampleCustomInput />}
          />
        )) ||
          (selectedPeriod.name === 'week' && (
            <>
              {`${format(
                new Date(selectedPeriod.startDate),
                DEFAULT_DATE_FORMATE,
              )} to ${format(
                new Date(selectedPeriod.endDate),
                DEFAULT_DATE_FORMATE,
              )}`}
            </>
          )) ||
          (selectedPeriod.name === 'month' && (
            <>
              {format(new Date(selectedPeriod.startDate), DEFAULT_DATE_FORMATE)}{' '}
              to{' '}
              {format(new Date(selectedPeriod.endDate), DEFAULT_DATE_FORMATE)}
            </>
          ))}
      </span>
      <span className="clear-left10" onClick={nextDate}>
        &#9654;
      </span>
      <span
        className={
          selectedPeriod.name !== 'day' ? 'hide' : 'appt-cal clear-left10'
        }
      >
        <img
          width="100%"
          src="./images/calendar-icon.png"
          alt=""
          onClick={openDatePicker}
        />
      </span>
    </div>
  );
}
